export const reactAppEnabled = 'react_application:enabled' // Never ever remove this feature toggle without solid reasoning

export const liveChat = 'liveChat'

export const appSwitcher = 'appSwitcher'

export const litmosSSO = 'litmosSSO'

export const contactList = 'contactsList'
